import React, { useState } from "react";

function SignUp({ setIsShowAuthForm, setResponse, setRegistrationProcessing }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setResponse("");
    let error = validateInput(name, email, phone, password);
    if (error !== true) {
      setResponse(error);
      return;
    }
    setRegistrationProcessing(true);
    fetch("https://ferry-backend.vercel.app/api/register", {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        name,
        email,
        phone,
        password,
      }),
    }).then((res) => {
      if (res.ok) {
        setRegistrationProcessing(false);
        setResponse("Registration successful!");
        setTimeout(() => {
          setIsShowAuthForm(false);
          document.getElementById("app-root").style.filter = "none";
        }, 2000);
      }
      if (res.status === 400) {
        setRegistrationProcessing(false);
        setResponse("User with such email already exists.");
      }
    });
  };

  const validateInput = (name, email, phone, password) => {
    if (name === "" || email === "" || phone === "" || password === "") {
      return "Fields cannot be empty, try again.";
    }
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      return "Invalid email format, try again.";
    }
    if (/[a-zA-Z]/.test(phone)) {
      return "Phone number cannot contain letters, try again.";
    }
    if (password.length < 8) {
      return "Password should be at least 8 characters long.";
    }
    if (!/[A-Z]/.test(password)) {
      return "Password should contain an uppercase letter.";
    }
    if (!/\d/.test(password)) {
      return "Password should contain a number.";
    }
    return true;
  };

  return (
    <form
      onSubmit={(e) => {
        setResponse("");
        handleSubmit(e);
      }}
    >
      <br />
      <div className="mb-3">
        <label>Name</label>
        <input
          type="text"
          className="form-control"
          placeholder="Name"
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <br />
      <div className="mb-3">
        <label>Email</label>
        <input
          type="text"
          className="form-control"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <br />
      <div className="mb-3">
        <label>Phone Number</label>
        <input
          type="text"
          className="form-control"
          placeholder="Phone"
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      <br />
      <div className="mb-3">
        <label>Password</label>
        <input
          type="password"
          className="form-control"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <br />
      <div className="d-grid">
        <button type="submit" className="login-btn">
          REGISTER
        </button>
      </div>
    </form>
  );
}

export default SignUp;
